import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";

export const adicionarDepartamento = async (departamento) => {

    let arrDepartamentos = await obtenerDoc('departamentos', 'departamentos')
    let deps = arrDepartamentos.data.departamentos
    deps.push(departamento)
    console.log(deps)
    let setDepatartamentos = new Set(deps)

    let arrNuevo = [...setDepatartamentos]

    return await actualizarDoc('departamentos', 'departamentos', {departamentos: arrNuevo})


}